/**
 * File: hodViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class HodViewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {
        $scope.loading= false
        let self = this;
        let selectedUserId = $stateParams.person_id
        let addedSessionsID = [];
        $scope.showSessionName = [];
        $scope.showCurriculumName = [];
        $scope.userMgt = {}
        $scope.selected_classes = []
        $scope.selected_phase = []
        $scope.selected_curriculum = {}
        $scope.selected_session = {}
        $scope.allClasses = []
        $scope.firstLoad = true //flag to check the page is loaded first or not
        $scope.showAddBtn = false

        let module_privileges = localStorageService.get("feature_privileges")


        $scope.userAccess = {}
        let features = module_privileges;
        let userAccessJson = _.filter(features, function(feature) {
            return feature.module_state == "userEndorsement";
        });
        if (userAccessJson) {
            _.each(userAccessJson, function(feature) {
                let user_access = {};
                _.each(feature.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userAccess = user_access;
            })
        } else {
            $state.go("dashboard")
        }


        self.myStudents = [];
        if (!selectedUserId) {
            $state.go('profileSetting');
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get endorsed department
         **/
        let hodEndorsedDept = () => {
            try {
                $scope.roleHOD = true;
                $scope.loading = true
                authService.callAPI(profileCons.API_HOD_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, (response) => {
                    if (response.result && response.result.data && response.result.data.departments) {
                        $scope.hodPersonArr = response.result.data.departments
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }else{
                        toastr.error("Failed to fetch data.")
                    }
                    $scope.loading = false
                    $scope.$apply()
                }) 
            } catch (error) {
                toastr.error("Failed to Fetch data.")
                $scope.loading = false 
            }
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load session list
         **/
        let sessionDet = () => {
            authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.sessionLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load curriculum list
         **/
        let curriculumDet = (session_id) => {
            $scope.loading = true
            try {
                authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, (response) => {
                    //console.log(response)
                    if (response.result && response.result.data && response.result.data.details) {
                        $scope.curriculumLst = response.result.data.details
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }
                        $scope.loading = false
                        $scope.$apply()  
                })
            } catch (error) {
                console.log(error);
                $scope.loading = false
                $scope.$apply()
            }
        
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load subject list
         **/
        let departmentDet = (curriculum_id) => {
            try {
                $scope.loading = true
                authService.callAPI(profileCons.API_GET_SUBJECTS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id+ "/"+selectedUserId, "GET", {}, (response) => {
                    //console.log(response)
                    if (response.result && response.result.data && response.result.data.details) {
                        $scope.subjectLst = response.result.data.details
                        if($scope.subjectLst && $scope.subjectLst.length){
                            $scope.subjectLst = $scope.subjectLst.map((eachSub)=>{
                                eachSub.is_selected = false
                                return eachSub
                            })
                        }
                        // Filter out duplicate objects in the $scope.subjectLst array based on the _id property.
                        // The filter checks if the current item's index matches the first occurrence of an item with the same _id.
                        // This ensures that only unique objects remain in the array.
                        let unique_subject_list=[]
                        try {
                            unique_subject_list = Array.isArray($scope.subjectLst)
                                ? $scope.subjectLst.filter((current_item, index_of_current_item, subjectList) => {
                                    return index_of_current_item === subjectList.findIndex((each_subject_obj) =>
                                        current_item._id.toString() === each_subject_obj._id.toString()
                                    );
                                })
                                : [];
                            $scope.subjectLst = unique_subject_list
                        } catch (error) {
                            console.log("Error occured while removing duplicates : hodViewController: /profileSetting/controllers/hodViewController.js  : line 151")
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });
                        updateSubjectDropdown()
                    }
                    $scope.loading = false
                    $scope.$apply();
                })   
            } catch (error) {
                toastr.error("Error getting Subjects")
                $scope.loading = false
            }
         
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: update department
         **/
        let updateDepartment = (academic_obj, user_id) => {
            try {
                $scope.loading = true
                let obj = {
                    curriculum_id: academic_obj.curriculum_id,
                    session_id: academic_obj.session_id,
                    school_id: localStorageService.get('school_id'),
                    subjects: academic_obj.subjects,
                    user_id: user_id,
                    phases : $scope.selected_phase
                }
                authService.callAPI(profileCons.API_UPDATE_DEPARTMENT, "POST", obj, (response) => {
                    if (response.result && response.result.status && response.result.status.code == 200) {
                        toastr.success("Updated successfully.")
                    }
                    else{
                        toastr.error("Update Failed.");
                    }
                    $scope.loading = false
                    $scope.firstLoad = false
                    $scope.userMgt = {};
                    hodEndorsedDept()
                    $scope.showAddBtn = false;
                    $scope.curriculumLst = [];
                    $scope.subjectLst = [];
                    $scope.selected_classes = [];
                    $scope.selected_phase = []
                    $scope.Phases = []
                    $scope.$apply();
                })
                
            } catch (error) {
                toastr.error("Update Failed .")
                $scope.loading = false
            }
          
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Remove department
         **/
        let removeDepartment = (user_id, academic_obj) => {
            try {
                $scope.loading =true
                let obj = {
                    curriculum_id: academic_obj.hod_class_details.curriculum._id,
                    session_id: academic_obj.hod_class_details.session._id,
                    subject_id: academic_obj.hod_class_details.subject._id,
                    phase_id: academic_obj.hod_class_details.phase._id,
    
                    user_id: user_id
                }
                authService.callAPI(profileCons.API_DELETE_DEPARTMENT, "POST", obj, (response) => {
                    if (response.result && response.result.status && response.result.status.code == 200) {
                        hodEndorsedDept()
                        toastr.success("Deleted successfully.")
                       
                    }else{
                        toastr.error("Delete Failed.")
                    }
                    $scope.loading = false
                    $scope.$apply();
                })
                
            } catch (error) {
                toastr.success("Failed to Delete.")
                $scope.loading = false
            }
            
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Initialization
         **/
        this.$onInit = () => {
            hodEndorsedDept()
            sessionDet()
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load curriculum list
         **/
        $scope.getCuriculumLst = (session_id) => {
            $scope.selected_session = session_id
            curriculumDet(session_id)
           if($scope.userMgt && $scope.userMgt.curriculum_id){
            $scope.userMgt.curriculum_id = null
           }   
           if($scope.userMgt && $scope.userMgt.subjects){
            $scope.userMgt.subjects = null
            $scope.subjectLst = []
            if(!$scope.subjectLst.length){
                $scope.showAddBtn = false
            }
           }   
          
           if($scope.userMgt.phases && $scope.userMgt.phases){
            $scope.userMgt.phases = null
            $scope.Phases = []
           } 
           if($scope.selected_phase.length > 0){
            $scope.selected_phase =[]
            $scope.selected_classes = []
           }
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load subject list
         **/
        // $scope.getSubjectsLst = (curriculum_id) => {
        //     departmentDet(curriculum_id)
        // }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to update department
         **/
        $scope.updateDepartment = () => {
            $scope.userMgt.school_id = localStorageService.get('school_id')
            if ($scope.userMgt.curriculum_id !== undefined && $scope.userMgt.session_id !== undefined) {
                if ($scope.userMgt.subjects && $scope.userMgt.subjects.length > 0) {
                    updateDepartment($scope.userMgt, selectedUserId)
                } else {
                    toastr.error("Please select atleast one subject")
                }
            } else {
                if ($scope.userMgt.curriculum_id === undefined && $scope.userMgt.session_id === undefined) {
                    toastr.error("Please select all necessary fields")
                } else {
                    if ($scope.userMgt.curriculum_id === undefined) {
                        toastr.error("Please select curriculum")
                    }
                    if ($scope.userMgt.session_id === undefined) {
                        toastr.error("Please select session")
                    }
                }
            }
        }

        function updateSubjectDropdown() {
            try {
                let hodPersonArr = $scope.hodPersonArr
                let selected_session = $scope.userMgt.session_id
                let selected_curriculum = $scope.userMgt.curriculum_id
                let used_subjects = []
                let selectedPhaseList = $scope.selected_phase.map((eachPhase) => eachPhase._id)
                if (selected_session && selected_curriculum) {
                    let userData = hodPersonArr
                    userData.forEach((data) => {
                        let user = data.hod_class_details
                        if (user) {
                            if (user.curriculum._id === selected_curriculum &&
                                user.session._id === selected_session &&
                                selectedPhaseList.includes(user.phase._id)
                            ) {
                                used_subjects.push(user.subject._id)
                            }
                        }
                    })
                    let subjectLst = $scope.subjectLst
                    subjectLst.forEach((sub) => {
                        if (used_subjects.includes(sub._id)) {
                            sub.is_selected = true
                        }
                    })
                }
            } catch (error) {
                toastr.error("Error in fetching user info")
            }
        }
        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to set visibility of add btn
         **/
        $scope.getData = () => {
            $scope.showAddBtn = true;
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to conform delete department
         **/
        $scope.deleteSubject = (department) => {
            let selectedUserId = $stateParams.person_id
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure to remove ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                removeDepartment(selectedUserId, department)
            }, function() {});
        }
        /**
         * @Author: Jayasurya
         * @Date: 2024-12-05
         * @Desc: Get phases based on the curriculum and session , get all classes
        **/
       $scope.getAllPhases = (curriculum)=>{
           $scope.loading = true
           if($scope.userMgt && $scope.userMgt.subjects){
            $scope.userMgt.subjects = null
            $scope.subjectLst = []
            if(!$scope.subjectLst.length){
                $scope.showAddBtn = false
            }
           }   
          
           if($scope.userMgt.phases && $scope.userMgt.phases){
            $scope.userMgt.phases = null
           } 
           if($scope.selected_phase.length > 0){
            $scope.selected_phase =[]
            $scope.selected_classes = []
           }
        $scope.selected_curriculum = curriculum
        const url = profileCons.API_GET_PHASES+"/"+localStorageService.get('school_id')+'/'+ $scope.selected_session +"/"+ $scope.selected_curriculum
        authService.callAPI(url,'GET', {}, (res)=>{
            try {
                if(res.result && res.result.data.Phases){
                    $scope.Phases = res.result.data.Phases.list 
                    $scope.allClasses = res.result.data.Classes 
                } 
                $scope.loading = false
            } catch (error) {
                console.log(error)
                $scope.loading = false
            }

            $scope.$apply();
        })
       }
        /** 
            * Filter the classes based on the based on the phase selected
            * 
        **/

         $scope.toTitleCase=(str)=> {
            return str.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
        /**
         * @Author: Jayasurya
         * @Date: 2024-12-27
         * @Desc: Show classes based on the phases selected
        **/
        $scope.showClassInfo = (selected_phase_list) => {
            if ($scope.userMgt && $scope.userMgt.subjects) {
                $scope.userMgt.subjects = null
                $scope.subjectLst = []
                if(!$scope.subjectLst.length){
                    $scope.showAddBtn = false
                }
            }
            if ($scope.selected_phase.length > 0) {
                $scope.selected_phase = []
                $scope.selected_classes = []
            }
            $scope.selected_phase = $scope.Phases.filter((eachPhase) => selected_phase_list.includes(eachPhase._id))
            if ($scope.selected_phase && $scope.selected_phase.length) {
                departmentDet($scope.selected_curriculum)
                try {
                     // Extract class IDs from the selected phases array and flatten them into a single array
                    let class_ids_seleted_phases = $scope.selected_phase.map((classArray) => classArray.class_ids).flat()
                     // Filter all classes to include only those matching the selected class IDs
                    $scope.selected_classes = Object.values($scope.allClasses)
                        .filter((classItem) => {
                            return class_ids_seleted_phases.includes(classItem._id)
                        })
                        .map((classItem) => {
                            // Format the class name to title case if it contains more than one word, otherwise keep it unchanged
                            return classItem.name.split(" ").length > 1 ? $scope.toTitleCase(classItem.name) : classItem.name
                        });
                } catch (error) {
                    toastr.error("Some error occured")
                    console.log(error);
                }

            }
        }
    }
}


export default HodViewController;


// WEBPACK FOOTER //
// ./src/app/profileSetting/controllers/hodViewController.js